import io from 'socket.io-client';
import pinia from './pinia';
import useUsersStore from '@/stores/users';

const socket = io('https://socket.bubbleplan.net', { // 'http://localhost:3003'
  autoConnect: false,
});

const usersStore = useUsersStore(pinia);

usersStore.userPromise.then((user) => {
  socket.io.opts.query = {
    token: user.jwt,
  };
  socket.open();
});

socket.io.on('reconnect_attempt', () => {
  socket.io.opts.query = {
    token: usersStore.user.jwt,
  };
});

// handle case when user reconnects and the token is expired
let authRefreshAttempted = false;
socket.on('connect', () => {
  authRefreshAttempted = false;
});
socket.on('connect_error', (error) => {
  if (authRefreshAttempted || error.message !== 'Authentication error') return;
  authRefreshAttempted = true;

  usersStore.getMe(true).then((user) => {
    socket.io.opts.query = {
      token: user.jwt,
    };
    socket.connect();
  }).catch(() => {});
});

socket.on('welcome', (message) => {
  console.log(message);
});

socket.on('error', (message) => {
  console.error(message);
});

export default socket;
